import sessionService from 'services/session.service';
import store from 'store/index';
import { logout, setTokens } from 'store/auth/auth';
import httpClient from '../index';
import * as apiServices from 'services/index';
//import { AxiosRequestConfig } from 'axios';

//export const sessionApiService = new SessionApiService();

/* tslint:disable:no-let */
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token) => {
  failedQueue.forEach((promise) => {
    if (error) {
      promise.reject(error);
    } else {
      promise.resolve(token);
    }
  });

  failedQueue = [];
};

export const sessionRecoveryInterceptor = {
  onFulFilled: (config) => config,
  onError: (error) => {
    const originalRequest = error?.config;
    const refreshToken = store.getState().auth.refreshToken; // get refresh token from react store
    if (originalRequest?.url.endsWith('/refresh')) {
      return Promise.reject(error);
    }

    if (error.response?.status === 400) {
      // do logout router.push({ name: 'logout' });
      return Promise.reject(error);
    }

    if (error.response?.status === 403) {
      store.dispatch(logout());
      return Promise.reject(error);
    }

    if (error.response?.status === 401) {
      // Logic to prevent double requests to refreshToken endpoint
      // when we have multiple parallel requests that return 401.
      if (isRefreshing) {
        return new Promise(function (resolve, reject) {
          failedQueue.push({ resolve, reject });
        })
          .then((token) => {
            setTimeout(() => {
              originalRequest.headers.Authorization = `Bearer ${token}`;
              return httpClient(originalRequest);
            });
          })
          .catch((err) => {
            return Promise.reject(err);
          });
      }

      isRefreshing = true;

      return new Promise(function (resolve, reject) {
        sessionService.refreshToken(refreshToken).then(
          ({ data }) => {
            // set tokenns on store
            store.dispatch(setTokens(data));

            //clearing received data for all APIs
            Object.values(apiServices).forEach((api) => {
              console.log({ api });
              if (api.util?.resetApiState) {
                store.dispatch(api.util.resetApiState());
              }
            });

            originalRequest.headers.Authorization = `Bearer ${data.access_token}`;

            processQueue(null, data.access_token);
            isRefreshing = false;
            // setTimeout(() => {
            //   return resolve(httpClient(originalRequest));
            // });
          },
          (err) => {
            processQueue(err, null);
            // push to logout
            console.log('push to logout');
            store.dispatch(logout());
            isRefreshing = false;

            reject(err);
          },
        );
      });
    }

    return Promise.reject(error);
  },
};
